const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'templates',
		'artCrm',
		'entity',
		'propertiesForm'
	],

	config: {
		contextClass: false
	},

	model: {
		changesGranted: false,
		forceViewChange: false,
		lastAddressType: null
	},

	events: {
		lazyloadScrollConnectionsTable: {
			type: 'mousewheel DOMMouseScroll',
			action: function(event){
				var self = event.data.component;

				// support connectionTable's lazy loading on scroll if possible
				if(self.config.contextClass !== 'treatAsContact'){
					self.find('templates_artCrm_connectionsTable_connectionsTable', function(connectionsTable){
						connectionsTable.onScrollLazyload();
					});
				}
			}
		}
	},

	methods: {
		onChange: function(){
			var self = this;
			var attributes = utils.merge(((self.resourceData || {}).data || {}).attributes || {}, ((self.model.dirtyFields || {}).data || {}).attributes || {});
			if(!self.model.changesGranted) {
				self.model.lastAddressType = attributes.addressType;
				return
			}

			var typesChanged = false;
			if((attributes.addressType || '') != (self.model.lastAddressType || '')) {
				if(attributes.addressID && attributes.addressType !== 'contact' && this.config.isReady){
					return self.performDecision(
						'confirm',
						{
							component:  self,
							title:      storage.__('addresses.form.changeTypeHint.title'),
							message:    storage.__('addresses.form.changeTypeHint.message'),
						}
					).then(function(context) {
						if (context.decision.type === 'yes') {
							self.model.lastAddressType = attributes.addressType;
							getComponent('artCrmController').propertiesFormChangeView('address', {
								addressType: 	attributes.addressType,
								isCompany: 		attributes.isCompany,
								$container: 	self.$
							});
						} else {
							getComponent(self.$.find('.base_form_fields_toggle[data-field-code="addressType"]')).select(self.model.lastAddressType);
						}
					})
				}

				self.model.lastAddressType = attributes.addressType;
				typesChanged = true;
			}
			if(attributes.isCompany != self.model.lastIsCompany) {
				self.model.lastIsCompany = attributes.isCompany;
				typesChanged = true;
			}
			if(typesChanged || self.model.forceViewChange){
				getComponent('artCrmController').propertiesFormChangeView('address', {
					addressType: 	attributes.addressType,
					isCompany: 		attributes.isCompany,
					$container: 	self.$
				});
			}
		},

		onSubmit: function(response){
			if(this.config.contextClass !== 'treatAsContact'){
				const entityData = response.data || {}

				// in case of tag save only processes the main address records will be left untouched.
				// therefor it may not be returned within the response and the last set of attributes will be taken instead.
				if(utils.collectionSize((entityData || {}).attributes) <= 0 && this.model.lastAddressAttributes){
					entityData.attributes = this.model.lastAddressAttributes
				}

				// whatever has opened this record in the first place may have information useful for later operations.
				entityData.parentEntity = this.model.recordController.model.parentEntity || {}

				return getComponent('artCrmController').showEdit(
					'address',
					entityData.attributes[entityData.primaryKey || 'id'],
					entityData,
					true,
					this.model.recordController.model.tabStrip,
					this.model.recordController.model.tabRegisterSecret
				);
			}
		},

		prepare: function(){
			this.model.nrOfTrips = 0;
			this.model.nrOfTrips += (((((this.resourceData.data || {}).children || {}).journalistsTrips || {}).data || []).length || 0);
			this.model.nrOfTrips += (((((this.resourceData.data || {}).children || {}).mediasTrips || {}).data || []).length || 0);
			this.model.nrOfTrips += (((((this.resourceData.data || {}).children || {}).clientsTrips || {}).data || []).length || 0);

			this.model.nrOfCooperations = 0;
			this.model.nrOfCooperations += (((((this.resourceData.data || {}).children || {}).clientsCooperations || {}).data || []).length || 0);
			this.model.nrOfCooperations += (((((this.resourceData.data || {}).children || {}).mediasCooperations || {}).data || []).length || 0);
			this.model.nrOfCooperations += (((((this.resourceData.data || {}).children || {}).contactsCooperations || {}).data || []).length || 0);
			this.model.nrOfCooperations += (((((this.resourceData.data || {}).children || {}).advisorsCooperations || {}).data || []).length || 0);
		}
	},

	hooks: {
		_postAttach: function($element, options){
			this.model.changesGranted = true;
			this.model.forceViewChange = true;
			if(this.config.contextClass === 'treatAsContact'){
				this.fieldToModel('addressType', 'contact');
			} else {
				this.onChange();
			}
			this.model.forceViewChange = false;
			if(utils.collectionSize((this.resourceData.data || {}).attributes) > 0){
				this.model.lastAddressAttributes = this.resourceData.data.attributes;
			}
		}
	},

	handlers: [{
		name: 'massAssignTags',
		handle: function(callerComponent) {
			if(this.config.isReady && callerComponent.hasClass('templates_artCrm_address_table')){
				this.refresh()
			}
		}
	}]
}